import React from 'react';
import {connect} from "react-redux";

import {Select} from 'components/common/uiKit';
import {OrderApi} from 'services/network/api';

class OrderSteps extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: []
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.Bill.Steps;

        OrderApi.GetOrderSteps()
            .then(res => {
                if (res && res.status == 200) {
                    let {data} = res;
                    data = data.map(x => {
                        const item = {
                            id: x.id,
                            name: pageTranslates[x.name]
                        };
                        return item;
                    });
                    this.setState({data});
                }
            })
    }

    render() {
        const {data} = this.state;
        const {value, onChange} = this.props;

        return (
            <div>
                <Select data={data} value={value} onChange={onChange}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(OrderSteps);

